import {
  getReadonlyListItemCurrency,
  getReadonlyListItemDate,
  getReadonlyListItemId,
  getReadonlyListItemNumber,
  getReadonlyListItemPill,
  getReadonlyListItemString,
  getReadonlyListItemTranslatedString,
} from '@interxfi/app-components/components/readonly-list/util';
import type { ReadonlyListItemRecord } from '@interxfi/design-system/components/list/readonly/item/readonly-list-item';
import type { ExcDtccUtcV1Trade } from '@interxfi/types/generated/api';
import { getOrderDetailPath } from '../../order/order-routing';
import { UtcTradeSidePill } from './utc-side-pill';

export function getUtcTradeListItems(data: ExcDtccUtcV1Trade | undefined, prefix = '') {
  return {
    orderId: getReadonlyListItemId(`${prefix}orderId`, 'Order ID', data?.orderId, getOrderDetailPath(data?.orderId)),
    clientOrderId: getReadonlyListItemId(`${prefix}clientOrderId`, 'Client Order ID', data?.clientOrderId),
    executionId: getReadonlyListItemId(`${prefix}executionId`, 'Execution ID', data?.executionId),
    marketControlNumber: getReadonlyListItemString(`${prefix}marketControlNumber`, 'Market Control Number', data?.marketControlNumber),
    symbol: getReadonlyListItemString(`${prefix}symbol`, 'Symbol', data?.symbol),
    cusip: getReadonlyListItemString(`${prefix}cusip`, 'CUSIP', data?.cusip),
    quantity: getReadonlyListItemNumber(`${prefix}quantity`, 'Quantity', data?.quantity),
    unitPrice: getReadonlyListItemCurrency(`${prefix}unitPrice`, 'Unit Price', data?.unitPrice),
    grossAmount: getReadonlyListItemCurrency(`${prefix}grossAmount`, 'Gross Amount', data?.grossAmount),
    netSettlementAmount: getReadonlyListItemCurrency(`${prefix}netSettlementAmount`, 'Net Settlement Amount', data?.netSettlementAmount),
    tradeDate: getReadonlyListItemDate(`${prefix}tradeDate`, 'Trade Date', data?.tradeDate, 'date_iso'),
    tradeTime: getReadonlyListItemDate(`${prefix}tradeTime`, 'Trade Time', data?.tradeTime, 'timestamp_iso_ms'),
    nettingIndicator: getReadonlyListItemTranslatedString(`${prefix}nettingIndicator`, 'Netting Indicator', {
      namespace: 'excDtccUtcV1',
      enumName: 'ExcDtccUtcV1NettingIndicator',
      value: data?.nettingIndicator,
    }),
    securityType: getReadonlyListItemTranslatedString(`${prefix}securityType`, 'Security Type', {
      namespace: 'excDtccUtcV1',
      enumName: 'ExcDtccUtcV1SecurityType',
      value: data?.securityType,
    }),
    settlementType: getReadonlyListItemTranslatedString(`${prefix}settlementType`, 'Settlement Type', {
      namespace: 'excDtccUtcV1',
      enumName: 'ExcDtccUtcV1SettlementType',
      value: data?.settlementType,
    }),
    settlementDate: getReadonlyListItemDate(`${prefix}settlementDate`, 'Settlement Date', data?.settlementDate, 'date_iso'),
    side: getReadonlyListItemTranslatedString(`${prefix}side`, 'Side', {
      namespace: 'excDtccUtcV1',
      enumName: 'ExcDtccUtcV1Side',
      value: data?.side,
    }),
    sidePill: getReadonlyListItemPill(`${prefix}sidePill`, 'Side', data?.side ? <UtcTradeSidePill side={data.side} /> : null),
  } as const satisfies ReadonlyListItemRecord;
}
